/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as PublicLandingRouteImport } from './routes/_public/_landing'
import { Route as PublicEmptyRouteImport } from './routes/_public/_empty'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/_onboarding'
import { Route as AuthenticatedMainRouteImport } from './routes/_authenticated/_main'
import { Route as AuthenticatedLandingRouteImport } from './routes/_authenticated/_landing'
import { Route as AuthenticatedEmptyRouteImport } from './routes/_authenticated/_empty'
import { Route as AuthenticatedMainIndexRouteImport } from './routes/_authenticated/_main/index'
import { Route as PublicLandingSignUpRouteImport } from './routes/_public/_landing/sign-up'
import { Route as PublicEmptySupport_feedbackRouteImport } from './routes/_public/_empty/support_feedback'
import { Route as PublicEmptyStylistsRouteImport } from './routes/_public/_empty/stylists'
import { Route as PublicEmptyStyleArticleRouteImport } from './routes/_public/_empty/style-article'
import { Route as PublicEmptySignInRouteImport } from './routes/_public/_empty/sign-in'
import { Route as PublicEmptyHighlightsRouteImport } from './routes/_public/_empty/highlights'
import { Route as PublicEmptyArticleRouteImport } from './routes/_public/_empty/article'
import { Route as PublicEmptySplatRouteImport } from './routes/_public/_empty/$'
import { Route as AuthenticatedMainSubscriptionRouteImport } from './routes/_authenticated/_main/subscription'
import { Route as AuthenticatedMainOutfitsRouteImport } from './routes/_authenticated/_main/outfits'
import { Route as AuthenticatedMainMyPlanRouteImport } from './routes/_authenticated/_main/my-plan'
import { Route as AuthenticatedMainMeRouteImport } from './routes/_authenticated/_main/me'
import { Route as AuthenticatedMainGuidesRouteImport } from './routes/_authenticated/_main/guides'
import { Route as AuthenticatedMainBookmarksRouteImport } from './routes/_authenticated/_main/bookmarks'
import { Route as AuthenticatedMainAccountRouteImport } from './routes/_authenticated/_main/account'
import { Route as AuthenticatedLandingRenewSubscriptionRouteImport } from './routes/_authenticated/_landing/renew-subscription'
import { Route as AuthenticatedEmptyUnsubscribeRouteImport } from './routes/_authenticated/_empty/unsubscribe'
import { Route as AuthenticatedMainStylePlanIndexRouteImport } from './routes/_authenticated/_main/style-plan/index'
import { Route as AuthenticatedMainInsightsIndexRouteImport } from './routes/_authenticated/_main/insights/index'
import { Route as AuthenticatedMainStylePlanDayRouteImport } from './routes/_authenticated/_main/style-plan/$day'
import { Route as AuthenticatedMainInsightsCategoryIdRouteImport } from './routes/_authenticated/_main/insights/$categoryId'
import { Route as AuthenticatedOnboardingOnboardingMyPlanIndexRouteImport } from './routes/_authenticated/_onboarding/onboarding/my-plan/index'
import { Route as AuthenticatedOnboardingOnboardingLoaderIndexRouteImport } from './routes/_authenticated/_onboarding/onboarding/loader/index'
import { Route as AuthenticatedOnboardingOnboardingMyPlanStepRouteImport } from './routes/_authenticated/_onboarding/onboarding/my-plan/$step'
import { Route as AuthenticatedMainInsightsCollectionCollectionIdRouteImport } from './routes/_authenticated/_main/insights/collection.$collectionId'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLandingRoute = PublicLandingRouteImport.update({
  id: '/_landing',
  getParentRoute: () => PublicRoute,
} as any)
const PublicEmptyRoute = PublicEmptyRouteImport.update({
  id: '/_empty',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: '/_onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMainRoute = AuthenticatedMainRouteImport.update({
  id: '/_main',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLandingRoute = AuthenticatedLandingRouteImport.update({
  id: '/_landing',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEmptyRoute = AuthenticatedEmptyRouteImport.update({
  id: '/_empty',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMainIndexRoute = AuthenticatedMainIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedMainRoute,
} as any)
const PublicLandingSignUpRoute = PublicLandingSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => PublicLandingRoute,
} as any)
const PublicEmptySupport_feedbackRoute =
  PublicEmptySupport_feedbackRouteImport.update({
    id: '/support_feedback',
    path: '/support_feedback',
    getParentRoute: () => PublicEmptyRoute,
  } as any)
const PublicEmptyStylistsRoute = PublicEmptyStylistsRouteImport.update({
  id: '/stylists',
  path: '/stylists',
  getParentRoute: () => PublicEmptyRoute,
} as any)
const PublicEmptyStyleArticleRoute = PublicEmptyStyleArticleRouteImport.update({
  id: '/style-article',
  path: '/style-article',
  getParentRoute: () => PublicEmptyRoute,
} as any)
const PublicEmptySignInRoute = PublicEmptySignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => PublicEmptyRoute,
} as any)
const PublicEmptyHighlightsRoute = PublicEmptyHighlightsRouteImport.update({
  id: '/highlights',
  path: '/highlights',
  getParentRoute: () => PublicEmptyRoute,
} as any)
const PublicEmptyArticleRoute = PublicEmptyArticleRouteImport.update({
  id: '/article',
  path: '/article',
  getParentRoute: () => PublicEmptyRoute,
} as any)
const PublicEmptySplatRoute = PublicEmptySplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => PublicEmptyRoute,
} as any)
const AuthenticatedMainSubscriptionRoute =
  AuthenticatedMainSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthenticatedMainRoute,
  } as any)
const AuthenticatedMainOutfitsRoute =
  AuthenticatedMainOutfitsRouteImport.update({
    id: '/outfits',
    path: '/outfits',
    getParentRoute: () => AuthenticatedMainRoute,
  } as any)
const AuthenticatedMainMyPlanRoute = AuthenticatedMainMyPlanRouteImport.update({
  id: '/my-plan',
  path: '/my-plan',
  getParentRoute: () => AuthenticatedMainRoute,
} as any)
const AuthenticatedMainMeRoute = AuthenticatedMainMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AuthenticatedMainRoute,
} as any)
const AuthenticatedMainGuidesRoute = AuthenticatedMainGuidesRouteImport.update({
  id: '/guides',
  path: '/guides',
  getParentRoute: () => AuthenticatedMainRoute,
} as any)
const AuthenticatedMainBookmarksRoute =
  AuthenticatedMainBookmarksRouteImport.update({
    id: '/bookmarks',
    path: '/bookmarks',
    getParentRoute: () => AuthenticatedMainRoute,
  } as any)
const AuthenticatedMainAccountRoute =
  AuthenticatedMainAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedMainRoute,
  } as any)
const AuthenticatedLandingRenewSubscriptionRoute =
  AuthenticatedLandingRenewSubscriptionRouteImport.update({
    id: '/renew-subscription',
    path: '/renew-subscription',
    getParentRoute: () => AuthenticatedLandingRoute,
  } as any)
const AuthenticatedEmptyUnsubscribeRoute =
  AuthenticatedEmptyUnsubscribeRouteImport.update({
    id: '/unsubscribe',
    path: '/unsubscribe',
    getParentRoute: () => AuthenticatedEmptyRoute,
  } as any)
const AuthenticatedMainStylePlanIndexRoute =
  AuthenticatedMainStylePlanIndexRouteImport.update({
    id: '/style-plan/',
    path: '/style-plan/',
    getParentRoute: () => AuthenticatedMainRoute,
  } as any)
const AuthenticatedMainInsightsIndexRoute =
  AuthenticatedMainInsightsIndexRouteImport.update({
    id: '/insights/',
    path: '/insights/',
    getParentRoute: () => AuthenticatedMainRoute,
  } as any)
const AuthenticatedMainStylePlanDayRoute =
  AuthenticatedMainStylePlanDayRouteImport.update({
    id: '/style-plan/$day',
    path: '/style-plan/$day',
    getParentRoute: () => AuthenticatedMainRoute,
  } as any)
const AuthenticatedMainInsightsCategoryIdRoute =
  AuthenticatedMainInsightsCategoryIdRouteImport.update({
    id: '/insights/$categoryId',
    path: '/insights/$categoryId',
    getParentRoute: () => AuthenticatedMainRoute,
  } as any)
const AuthenticatedOnboardingOnboardingMyPlanIndexRoute =
  AuthenticatedOnboardingOnboardingMyPlanIndexRouteImport.update({
    id: '/onboarding/my-plan/',
    path: '/onboarding/my-plan/',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)
const AuthenticatedOnboardingOnboardingLoaderIndexRoute =
  AuthenticatedOnboardingOnboardingLoaderIndexRouteImport.update({
    id: '/onboarding/loader/',
    path: '/onboarding/loader/',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)
const AuthenticatedOnboardingOnboardingMyPlanStepRoute =
  AuthenticatedOnboardingOnboardingMyPlanStepRouteImport.update({
    id: '/onboarding/my-plan/$step',
    path: '/onboarding/my-plan/$step',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)
const AuthenticatedMainInsightsCollectionCollectionIdRoute =
  AuthenticatedMainInsightsCollectionCollectionIdRouteImport.update({
    id: '/insights/collection/$collectionId',
    path: '/insights/collection/$collectionId',
    getParentRoute: () => AuthenticatedMainRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedMainIndexRoute
  '/unsubscribe': typeof AuthenticatedEmptyUnsubscribeRoute
  '/renew-subscription': typeof AuthenticatedLandingRenewSubscriptionRoute
  '/account': typeof AuthenticatedMainAccountRoute
  '/bookmarks': typeof AuthenticatedMainBookmarksRoute
  '/guides': typeof AuthenticatedMainGuidesRoute
  '/me': typeof AuthenticatedMainMeRoute
  '/my-plan': typeof AuthenticatedMainMyPlanRoute
  '/outfits': typeof AuthenticatedMainOutfitsRoute
  '/subscription': typeof AuthenticatedMainSubscriptionRoute
  '/$': typeof PublicEmptySplatRoute
  '/article': typeof PublicEmptyArticleRoute
  '/highlights': typeof PublicEmptyHighlightsRoute
  '/sign-in': typeof PublicEmptySignInRoute
  '/style-article': typeof PublicEmptyStyleArticleRoute
  '/stylists': typeof PublicEmptyStylistsRoute
  '/support_feedback': typeof PublicEmptySupport_feedbackRoute
  '/sign-up': typeof PublicLandingSignUpRoute
  '/insights/$categoryId': typeof AuthenticatedMainInsightsCategoryIdRoute
  '/style-plan/$day': typeof AuthenticatedMainStylePlanDayRoute
  '/insights/': typeof AuthenticatedMainInsightsIndexRoute
  '/style-plan/': typeof AuthenticatedMainStylePlanIndexRoute
  '/insights/collection/$collectionId': typeof AuthenticatedMainInsightsCollectionCollectionIdRoute
  '/onboarding/my-plan/$step': typeof AuthenticatedOnboardingOnboardingMyPlanStepRoute
  '/onboarding/loader/': typeof AuthenticatedOnboardingOnboardingLoaderIndexRoute
  '/onboarding/my-plan/': typeof AuthenticatedOnboardingOnboardingMyPlanIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedMainIndexRoute
  '/unsubscribe': typeof AuthenticatedEmptyUnsubscribeRoute
  '/renew-subscription': typeof AuthenticatedLandingRenewSubscriptionRoute
  '/account': typeof AuthenticatedMainAccountRoute
  '/bookmarks': typeof AuthenticatedMainBookmarksRoute
  '/guides': typeof AuthenticatedMainGuidesRoute
  '/me': typeof AuthenticatedMainMeRoute
  '/my-plan': typeof AuthenticatedMainMyPlanRoute
  '/outfits': typeof AuthenticatedMainOutfitsRoute
  '/subscription': typeof AuthenticatedMainSubscriptionRoute
  '/$': typeof PublicEmptySplatRoute
  '/article': typeof PublicEmptyArticleRoute
  '/highlights': typeof PublicEmptyHighlightsRoute
  '/sign-in': typeof PublicEmptySignInRoute
  '/style-article': typeof PublicEmptyStyleArticleRoute
  '/stylists': typeof PublicEmptyStylistsRoute
  '/support_feedback': typeof PublicEmptySupport_feedbackRoute
  '/sign-up': typeof PublicLandingSignUpRoute
  '/insights/$categoryId': typeof AuthenticatedMainInsightsCategoryIdRoute
  '/style-plan/$day': typeof AuthenticatedMainStylePlanDayRoute
  '/insights': typeof AuthenticatedMainInsightsIndexRoute
  '/style-plan': typeof AuthenticatedMainStylePlanIndexRoute
  '/insights/collection/$collectionId': typeof AuthenticatedMainInsightsCollectionCollectionIdRoute
  '/onboarding/my-plan/$step': typeof AuthenticatedOnboardingOnboardingMyPlanStepRoute
  '/onboarding/loader': typeof AuthenticatedOnboardingOnboardingLoaderIndexRoute
  '/onboarding/my-plan': typeof AuthenticatedOnboardingOnboardingMyPlanIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_authenticated/_empty': typeof AuthenticatedEmptyRouteWithChildren
  '/_authenticated/_landing': typeof AuthenticatedLandingRouteWithChildren
  '/_authenticated/_main': typeof AuthenticatedMainRouteWithChildren
  '/_authenticated/_onboarding': typeof AuthenticatedOnboardingRouteWithChildren
  '/_public/_empty': typeof PublicEmptyRouteWithChildren
  '/_public/_landing': typeof PublicLandingRouteWithChildren
  '/_authenticated/_empty/unsubscribe': typeof AuthenticatedEmptyUnsubscribeRoute
  '/_authenticated/_landing/renew-subscription': typeof AuthenticatedLandingRenewSubscriptionRoute
  '/_authenticated/_main/account': typeof AuthenticatedMainAccountRoute
  '/_authenticated/_main/bookmarks': typeof AuthenticatedMainBookmarksRoute
  '/_authenticated/_main/guides': typeof AuthenticatedMainGuidesRoute
  '/_authenticated/_main/me': typeof AuthenticatedMainMeRoute
  '/_authenticated/_main/my-plan': typeof AuthenticatedMainMyPlanRoute
  '/_authenticated/_main/outfits': typeof AuthenticatedMainOutfitsRoute
  '/_authenticated/_main/subscription': typeof AuthenticatedMainSubscriptionRoute
  '/_public/_empty/$': typeof PublicEmptySplatRoute
  '/_public/_empty/article': typeof PublicEmptyArticleRoute
  '/_public/_empty/highlights': typeof PublicEmptyHighlightsRoute
  '/_public/_empty/sign-in': typeof PublicEmptySignInRoute
  '/_public/_empty/style-article': typeof PublicEmptyStyleArticleRoute
  '/_public/_empty/stylists': typeof PublicEmptyStylistsRoute
  '/_public/_empty/support_feedback': typeof PublicEmptySupport_feedbackRoute
  '/_public/_landing/sign-up': typeof PublicLandingSignUpRoute
  '/_authenticated/_main/': typeof AuthenticatedMainIndexRoute
  '/_authenticated/_main/insights/$categoryId': typeof AuthenticatedMainInsightsCategoryIdRoute
  '/_authenticated/_main/style-plan/$day': typeof AuthenticatedMainStylePlanDayRoute
  '/_authenticated/_main/insights/': typeof AuthenticatedMainInsightsIndexRoute
  '/_authenticated/_main/style-plan/': typeof AuthenticatedMainStylePlanIndexRoute
  '/_authenticated/_main/insights/collection/$collectionId': typeof AuthenticatedMainInsightsCollectionCollectionIdRoute
  '/_authenticated/_onboarding/onboarding/my-plan/$step': typeof AuthenticatedOnboardingOnboardingMyPlanStepRoute
  '/_authenticated/_onboarding/onboarding/loader/': typeof AuthenticatedOnboardingOnboardingLoaderIndexRoute
  '/_authenticated/_onboarding/onboarding/my-plan/': typeof AuthenticatedOnboardingOnboardingMyPlanIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/unsubscribe'
    | '/renew-subscription'
    | '/account'
    | '/bookmarks'
    | '/guides'
    | '/me'
    | '/my-plan'
    | '/outfits'
    | '/subscription'
    | '/$'
    | '/article'
    | '/highlights'
    | '/sign-in'
    | '/style-article'
    | '/stylists'
    | '/support_feedback'
    | '/sign-up'
    | '/insights/$categoryId'
    | '/style-plan/$day'
    | '/insights/'
    | '/style-plan/'
    | '/insights/collection/$collectionId'
    | '/onboarding/my-plan/$step'
    | '/onboarding/loader/'
    | '/onboarding/my-plan/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/unsubscribe'
    | '/renew-subscription'
    | '/account'
    | '/bookmarks'
    | '/guides'
    | '/me'
    | '/my-plan'
    | '/outfits'
    | '/subscription'
    | '/$'
    | '/article'
    | '/highlights'
    | '/sign-in'
    | '/style-article'
    | '/stylists'
    | '/support_feedback'
    | '/sign-up'
    | '/insights/$categoryId'
    | '/style-plan/$day'
    | '/insights'
    | '/style-plan'
    | '/insights/collection/$collectionId'
    | '/onboarding/my-plan/$step'
    | '/onboarding/loader'
    | '/onboarding/my-plan'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_public'
    | '/_authenticated/_empty'
    | '/_authenticated/_landing'
    | '/_authenticated/_main'
    | '/_authenticated/_onboarding'
    | '/_public/_empty'
    | '/_public/_landing'
    | '/_authenticated/_empty/unsubscribe'
    | '/_authenticated/_landing/renew-subscription'
    | '/_authenticated/_main/account'
    | '/_authenticated/_main/bookmarks'
    | '/_authenticated/_main/guides'
    | '/_authenticated/_main/me'
    | '/_authenticated/_main/my-plan'
    | '/_authenticated/_main/outfits'
    | '/_authenticated/_main/subscription'
    | '/_public/_empty/$'
    | '/_public/_empty/article'
    | '/_public/_empty/highlights'
    | '/_public/_empty/sign-in'
    | '/_public/_empty/style-article'
    | '/_public/_empty/stylists'
    | '/_public/_empty/support_feedback'
    | '/_public/_landing/sign-up'
    | '/_authenticated/_main/'
    | '/_authenticated/_main/insights/$categoryId'
    | '/_authenticated/_main/style-plan/$day'
    | '/_authenticated/_main/insights/'
    | '/_authenticated/_main/style-plan/'
    | '/_authenticated/_main/insights/collection/$collectionId'
    | '/_authenticated/_onboarding/onboarding/my-plan/$step'
    | '/_authenticated/_onboarding/onboarding/loader/'
    | '/_authenticated/_onboarding/onboarding/my-plan/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/_landing': {
      id: '/_public/_landing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicLandingRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/_empty': {
      id: '/_public/_empty'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicEmptyRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/_onboarding': {
      id: '/_authenticated/_onboarding'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_main': {
      id: '/_authenticated/_main'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedMainRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_landing': {
      id: '/_authenticated/_landing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLandingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_empty': {
      id: '/_authenticated/_empty'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedEmptyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_main/': {
      id: '/_authenticated/_main/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedMainIndexRouteImport
      parentRoute: typeof AuthenticatedMainRoute
    }
    '/_public/_landing/sign-up': {
      id: '/_public/_landing/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof PublicLandingSignUpRouteImport
      parentRoute: typeof PublicLandingRoute
    }
    '/_public/_empty/support_feedback': {
      id: '/_public/_empty/support_feedback'
      path: '/support_feedback'
      fullPath: '/support_feedback'
      preLoaderRoute: typeof PublicEmptySupport_feedbackRouteImport
      parentRoute: typeof PublicEmptyRoute
    }
    '/_public/_empty/stylists': {
      id: '/_public/_empty/stylists'
      path: '/stylists'
      fullPath: '/stylists'
      preLoaderRoute: typeof PublicEmptyStylistsRouteImport
      parentRoute: typeof PublicEmptyRoute
    }
    '/_public/_empty/style-article': {
      id: '/_public/_empty/style-article'
      path: '/style-article'
      fullPath: '/style-article'
      preLoaderRoute: typeof PublicEmptyStyleArticleRouteImport
      parentRoute: typeof PublicEmptyRoute
    }
    '/_public/_empty/sign-in': {
      id: '/_public/_empty/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof PublicEmptySignInRouteImport
      parentRoute: typeof PublicEmptyRoute
    }
    '/_public/_empty/highlights': {
      id: '/_public/_empty/highlights'
      path: '/highlights'
      fullPath: '/highlights'
      preLoaderRoute: typeof PublicEmptyHighlightsRouteImport
      parentRoute: typeof PublicEmptyRoute
    }
    '/_public/_empty/article': {
      id: '/_public/_empty/article'
      path: '/article'
      fullPath: '/article'
      preLoaderRoute: typeof PublicEmptyArticleRouteImport
      parentRoute: typeof PublicEmptyRoute
    }
    '/_public/_empty/$': {
      id: '/_public/_empty/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof PublicEmptySplatRouteImport
      parentRoute: typeof PublicEmptyRoute
    }
    '/_authenticated/_main/subscription': {
      id: '/_authenticated/_main/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof AuthenticatedMainSubscriptionRouteImport
      parentRoute: typeof AuthenticatedMainRoute
    }
    '/_authenticated/_main/outfits': {
      id: '/_authenticated/_main/outfits'
      path: '/outfits'
      fullPath: '/outfits'
      preLoaderRoute: typeof AuthenticatedMainOutfitsRouteImport
      parentRoute: typeof AuthenticatedMainRoute
    }
    '/_authenticated/_main/my-plan': {
      id: '/_authenticated/_main/my-plan'
      path: '/my-plan'
      fullPath: '/my-plan'
      preLoaderRoute: typeof AuthenticatedMainMyPlanRouteImport
      parentRoute: typeof AuthenticatedMainRoute
    }
    '/_authenticated/_main/me': {
      id: '/_authenticated/_main/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof AuthenticatedMainMeRouteImport
      parentRoute: typeof AuthenticatedMainRoute
    }
    '/_authenticated/_main/guides': {
      id: '/_authenticated/_main/guides'
      path: '/guides'
      fullPath: '/guides'
      preLoaderRoute: typeof AuthenticatedMainGuidesRouteImport
      parentRoute: typeof AuthenticatedMainRoute
    }
    '/_authenticated/_main/bookmarks': {
      id: '/_authenticated/_main/bookmarks'
      path: '/bookmarks'
      fullPath: '/bookmarks'
      preLoaderRoute: typeof AuthenticatedMainBookmarksRouteImport
      parentRoute: typeof AuthenticatedMainRoute
    }
    '/_authenticated/_main/account': {
      id: '/_authenticated/_main/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedMainAccountRouteImport
      parentRoute: typeof AuthenticatedMainRoute
    }
    '/_authenticated/_landing/renew-subscription': {
      id: '/_authenticated/_landing/renew-subscription'
      path: '/renew-subscription'
      fullPath: '/renew-subscription'
      preLoaderRoute: typeof AuthenticatedLandingRenewSubscriptionRouteImport
      parentRoute: typeof AuthenticatedLandingRoute
    }
    '/_authenticated/_empty/unsubscribe': {
      id: '/_authenticated/_empty/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof AuthenticatedEmptyUnsubscribeRouteImport
      parentRoute: typeof AuthenticatedEmptyRoute
    }
    '/_authenticated/_main/style-plan/': {
      id: '/_authenticated/_main/style-plan/'
      path: '/style-plan'
      fullPath: '/style-plan/'
      preLoaderRoute: typeof AuthenticatedMainStylePlanIndexRouteImport
      parentRoute: typeof AuthenticatedMainRoute
    }
    '/_authenticated/_main/insights/': {
      id: '/_authenticated/_main/insights/'
      path: '/insights'
      fullPath: '/insights/'
      preLoaderRoute: typeof AuthenticatedMainInsightsIndexRouteImport
      parentRoute: typeof AuthenticatedMainRoute
    }
    '/_authenticated/_main/style-plan/$day': {
      id: '/_authenticated/_main/style-plan/$day'
      path: '/style-plan/$day'
      fullPath: '/style-plan/$day'
      preLoaderRoute: typeof AuthenticatedMainStylePlanDayRouteImport
      parentRoute: typeof AuthenticatedMainRoute
    }
    '/_authenticated/_main/insights/$categoryId': {
      id: '/_authenticated/_main/insights/$categoryId'
      path: '/insights/$categoryId'
      fullPath: '/insights/$categoryId'
      preLoaderRoute: typeof AuthenticatedMainInsightsCategoryIdRouteImport
      parentRoute: typeof AuthenticatedMainRoute
    }
    '/_authenticated/_onboarding/onboarding/my-plan/': {
      id: '/_authenticated/_onboarding/onboarding/my-plan/'
      path: '/onboarding/my-plan'
      fullPath: '/onboarding/my-plan/'
      preLoaderRoute: typeof AuthenticatedOnboardingOnboardingMyPlanIndexRouteImport
      parentRoute: typeof AuthenticatedOnboardingRoute
    }
    '/_authenticated/_onboarding/onboarding/loader/': {
      id: '/_authenticated/_onboarding/onboarding/loader/'
      path: '/onboarding/loader'
      fullPath: '/onboarding/loader/'
      preLoaderRoute: typeof AuthenticatedOnboardingOnboardingLoaderIndexRouteImport
      parentRoute: typeof AuthenticatedOnboardingRoute
    }
    '/_authenticated/_onboarding/onboarding/my-plan/$step': {
      id: '/_authenticated/_onboarding/onboarding/my-plan/$step'
      path: '/onboarding/my-plan/$step'
      fullPath: '/onboarding/my-plan/$step'
      preLoaderRoute: typeof AuthenticatedOnboardingOnboardingMyPlanStepRouteImport
      parentRoute: typeof AuthenticatedOnboardingRoute
    }
    '/_authenticated/_main/insights/collection/$collectionId': {
      id: '/_authenticated/_main/insights/collection/$collectionId'
      path: '/insights/collection/$collectionId'
      fullPath: '/insights/collection/$collectionId'
      preLoaderRoute: typeof AuthenticatedMainInsightsCollectionCollectionIdRouteImport
      parentRoute: typeof AuthenticatedMainRoute
    }
  }
}

interface AuthenticatedEmptyRouteChildren {
  AuthenticatedEmptyUnsubscribeRoute: typeof AuthenticatedEmptyUnsubscribeRoute
}

const AuthenticatedEmptyRouteChildren: AuthenticatedEmptyRouteChildren = {
  AuthenticatedEmptyUnsubscribeRoute: AuthenticatedEmptyUnsubscribeRoute,
}

const AuthenticatedEmptyRouteWithChildren =
  AuthenticatedEmptyRoute._addFileChildren(AuthenticatedEmptyRouteChildren)

interface AuthenticatedLandingRouteChildren {
  AuthenticatedLandingRenewSubscriptionRoute: typeof AuthenticatedLandingRenewSubscriptionRoute
}

const AuthenticatedLandingRouteChildren: AuthenticatedLandingRouteChildren = {
  AuthenticatedLandingRenewSubscriptionRoute:
    AuthenticatedLandingRenewSubscriptionRoute,
}

const AuthenticatedLandingRouteWithChildren =
  AuthenticatedLandingRoute._addFileChildren(AuthenticatedLandingRouteChildren)

interface AuthenticatedMainRouteChildren {
  AuthenticatedMainAccountRoute: typeof AuthenticatedMainAccountRoute
  AuthenticatedMainBookmarksRoute: typeof AuthenticatedMainBookmarksRoute
  AuthenticatedMainGuidesRoute: typeof AuthenticatedMainGuidesRoute
  AuthenticatedMainMeRoute: typeof AuthenticatedMainMeRoute
  AuthenticatedMainMyPlanRoute: typeof AuthenticatedMainMyPlanRoute
  AuthenticatedMainOutfitsRoute: typeof AuthenticatedMainOutfitsRoute
  AuthenticatedMainSubscriptionRoute: typeof AuthenticatedMainSubscriptionRoute
  AuthenticatedMainIndexRoute: typeof AuthenticatedMainIndexRoute
  AuthenticatedMainInsightsCategoryIdRoute: typeof AuthenticatedMainInsightsCategoryIdRoute
  AuthenticatedMainStylePlanDayRoute: typeof AuthenticatedMainStylePlanDayRoute
  AuthenticatedMainInsightsIndexRoute: typeof AuthenticatedMainInsightsIndexRoute
  AuthenticatedMainStylePlanIndexRoute: typeof AuthenticatedMainStylePlanIndexRoute
  AuthenticatedMainInsightsCollectionCollectionIdRoute: typeof AuthenticatedMainInsightsCollectionCollectionIdRoute
}

const AuthenticatedMainRouteChildren: AuthenticatedMainRouteChildren = {
  AuthenticatedMainAccountRoute: AuthenticatedMainAccountRoute,
  AuthenticatedMainBookmarksRoute: AuthenticatedMainBookmarksRoute,
  AuthenticatedMainGuidesRoute: AuthenticatedMainGuidesRoute,
  AuthenticatedMainMeRoute: AuthenticatedMainMeRoute,
  AuthenticatedMainMyPlanRoute: AuthenticatedMainMyPlanRoute,
  AuthenticatedMainOutfitsRoute: AuthenticatedMainOutfitsRoute,
  AuthenticatedMainSubscriptionRoute: AuthenticatedMainSubscriptionRoute,
  AuthenticatedMainIndexRoute: AuthenticatedMainIndexRoute,
  AuthenticatedMainInsightsCategoryIdRoute:
    AuthenticatedMainInsightsCategoryIdRoute,
  AuthenticatedMainStylePlanDayRoute: AuthenticatedMainStylePlanDayRoute,
  AuthenticatedMainInsightsIndexRoute: AuthenticatedMainInsightsIndexRoute,
  AuthenticatedMainStylePlanIndexRoute: AuthenticatedMainStylePlanIndexRoute,
  AuthenticatedMainInsightsCollectionCollectionIdRoute:
    AuthenticatedMainInsightsCollectionCollectionIdRoute,
}

const AuthenticatedMainRouteWithChildren =
  AuthenticatedMainRoute._addFileChildren(AuthenticatedMainRouteChildren)

interface AuthenticatedOnboardingRouteChildren {
  AuthenticatedOnboardingOnboardingMyPlanStepRoute: typeof AuthenticatedOnboardingOnboardingMyPlanStepRoute
  AuthenticatedOnboardingOnboardingLoaderIndexRoute: typeof AuthenticatedOnboardingOnboardingLoaderIndexRoute
  AuthenticatedOnboardingOnboardingMyPlanIndexRoute: typeof AuthenticatedOnboardingOnboardingMyPlanIndexRoute
}

const AuthenticatedOnboardingRouteChildren: AuthenticatedOnboardingRouteChildren =
  {
    AuthenticatedOnboardingOnboardingMyPlanStepRoute:
      AuthenticatedOnboardingOnboardingMyPlanStepRoute,
    AuthenticatedOnboardingOnboardingLoaderIndexRoute:
      AuthenticatedOnboardingOnboardingLoaderIndexRoute,
    AuthenticatedOnboardingOnboardingMyPlanIndexRoute:
      AuthenticatedOnboardingOnboardingMyPlanIndexRoute,
  }

const AuthenticatedOnboardingRouteWithChildren =
  AuthenticatedOnboardingRoute._addFileChildren(
    AuthenticatedOnboardingRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedEmptyRoute: typeof AuthenticatedEmptyRouteWithChildren
  AuthenticatedLandingRoute: typeof AuthenticatedLandingRouteWithChildren
  AuthenticatedMainRoute: typeof AuthenticatedMainRouteWithChildren
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedEmptyRoute: AuthenticatedEmptyRouteWithChildren,
  AuthenticatedLandingRoute: AuthenticatedLandingRouteWithChildren,
  AuthenticatedMainRoute: AuthenticatedMainRouteWithChildren,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicEmptyRouteChildren {
  PublicEmptySplatRoute: typeof PublicEmptySplatRoute
  PublicEmptyArticleRoute: typeof PublicEmptyArticleRoute
  PublicEmptyHighlightsRoute: typeof PublicEmptyHighlightsRoute
  PublicEmptySignInRoute: typeof PublicEmptySignInRoute
  PublicEmptyStyleArticleRoute: typeof PublicEmptyStyleArticleRoute
  PublicEmptyStylistsRoute: typeof PublicEmptyStylistsRoute
  PublicEmptySupport_feedbackRoute: typeof PublicEmptySupport_feedbackRoute
}

const PublicEmptyRouteChildren: PublicEmptyRouteChildren = {
  PublicEmptySplatRoute: PublicEmptySplatRoute,
  PublicEmptyArticleRoute: PublicEmptyArticleRoute,
  PublicEmptyHighlightsRoute: PublicEmptyHighlightsRoute,
  PublicEmptySignInRoute: PublicEmptySignInRoute,
  PublicEmptyStyleArticleRoute: PublicEmptyStyleArticleRoute,
  PublicEmptyStylistsRoute: PublicEmptyStylistsRoute,
  PublicEmptySupport_feedbackRoute: PublicEmptySupport_feedbackRoute,
}

const PublicEmptyRouteWithChildren = PublicEmptyRoute._addFileChildren(
  PublicEmptyRouteChildren,
)

interface PublicLandingRouteChildren {
  PublicLandingSignUpRoute: typeof PublicLandingSignUpRoute
}

const PublicLandingRouteChildren: PublicLandingRouteChildren = {
  PublicLandingSignUpRoute: PublicLandingSignUpRoute,
}

const PublicLandingRouteWithChildren = PublicLandingRoute._addFileChildren(
  PublicLandingRouteChildren,
)

interface PublicRouteChildren {
  PublicEmptyRoute: typeof PublicEmptyRouteWithChildren
  PublicLandingRoute: typeof PublicLandingRouteWithChildren
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicEmptyRoute: PublicEmptyRouteWithChildren,
  PublicLandingRoute: PublicLandingRouteWithChildren,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
